import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Portfolio from '../Portfolio/Portfolio';

const Porfolios = () => {
    const [portfolios, setPortfolios] = useState([])
    useEffect(() => {
        fetch('https://calm-dawn-17727.herokuapp.com/projects')
            .then(res => res.json())
            .then(data => setPortfolios(data))
    }, [])
    return (
        <div>
            <h2 className="my-5 pt-5">My resent project</h2>
            <Row xs={1} md={3} className="g-2">
                {
                    portfolios.map(portfolio => <Portfolio portfolio={portfolio}></Portfolio>)
                }
            </Row>
        </div>
    );
};

export default Porfolios;